import * as yup from 'yup';
import * as Schema from '../schemaFields';

export const editGameDateSchema = yup.object({
  startDate: Schema.requiredDate,
  startHour: Schema.requiredDate,
  endDate: Schema.requiredDate,
  endHour: Schema.endDateTimeAfterStart,
});
